webpackJsonp([40],{

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(124)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(285)
var prodEnv = __webpack_require__(74)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(276)

module.exports = {
  build: {
    env: __webpack_require__(74),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/public/wap/dist/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(137),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(22);




window.AppJumpProtocol = '';
window.AppThemeColor = '';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      themecolor: '',
      isLimited: false,
      showFixedIndex: false,
      showPostForum: false,
      showPostWshare: false,
      showBar: false,
      appInfo: {},
      isInWeixin: this.$utils.pageIsInThirdPlatform()
    };
  },

  watch: {
    '$route': function $route() {
      var routeName = this.$route.name;
      if (routeName !== 'UserHome' && routeName !== 'CirclePostList' && routeName !== 'WshareList' && routeName !== 'TopicIndex') {
        this.$utils.setShareData();
      }
      document.title = this.$route.meta.title ? this.$route.meta.title : '';
      this.showFixedIndex = routeName !== 'Entry' && routeName !== 'Index' && routeName !== 'Circle' && routeName !== 'Find' && routeName !== 'User' && routeName !== 'CirclePost' && routeName !== 'WsharePost' && routeName !== 'Wshare';
      this.showBar = routeName !== 'CirclePost' && routeName !== 'WsharePost' && routeName !== 'merchantList';
      this.showPostForum = routeName === 'CirclePostList' || routeName === 'merchantCircle';
      this.showPostWshare = routeName === 'WshareList' || routeName === 'TopicIndex' || routeName === 'Wshare';
    }
  },
  created: function created() {
    var me = this;
    var doc = document,
        themecolor = '',
        mystyle = doc.createElement('style');
    mystyle.setAttribute('type', 'text/css');
    this.$store.dispatch('loadGlobalConfig').then(function (data) {
      me.appInfo = data.appInfo;
      me.isLimited = parseInt(data.global_wap_limited_interaction) === 1;
      window.ShareTitle = data.appInfo.app_name;
      window.ShareDesc = data.appInfo.app_des;
      window.ShareIcon = data.appInfo.app_logo;
      me.$utils.setShareData();
      window.AppJumpProtocol = data.appInfo.app_key;
      if (data.global_theme_tones) {
        themecolor = data.global_theme_tones.replace('#', '');
      } else {
        themecolor = '42BD56';
      }
      me.themecolor = themecolor;
      window.AppThemeColor = themecolor;
      me.$utils.appendThemeColorStyleNode(themecolor);
      data.wap_tab_items.forEach(function (val, idx, arr) {
        mystyle.innerHTML += '.btm-tabbar .icon-w[dataindex="' + idx + '"]{ background-image:url(' + val.icon + '); } .btm-tabbar .item.router-link-exact-active .icon-w[dataindex="' + idx + '"]{ background-image:url(' + val.icon_active + '); } ';
      });
      doc.getElementsByTagName('head')[0].appendChild(mystyle);

      var locationQueryDict = me.$utils.locationSearchParser(),
          isRedirected = typeof locationQueryDict.magshareredirect !== 'undefined' && parseInt(locationQueryDict.magshareredirect) === 1;
      if (isRedirected) {
        $('.app-jump-overlay').fadeIn('fast', function () {
          $(this).find('.button-installed').attr('href', window.AppJumpProtocol + '://pagejump?jump_url=' + me.jumpurl);
        });
      }
    });
  },
  mounted: function mounted() {
    var me = this;
    $(document).on('click', '.hooker-for-jumpapp', function () {
      me.jumpToAppPage();
    });
    $('.app-jump-overlay').on('click', function (evt) {
      if (!$(evt.target).hasClass('app-jump-dialog') && !$(evt.target).parents().hasClass('app-jump-dialog')) {
        $(this).fadeOut("fast");
      }
    });
  },

  methods: {
    goPostWshare: function goPostWshare() {
      if (this.isLimited) {
        location.href = this.appInfo.app_download;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({
          name: 'WsharePost',
          query: {
            circle_id: this.$route.query.circle_id || '',
            name: this.$route.query.name || '',
            topic_name: this.$route.query.topic_name || ''
          }
        });
      }
    },
    goPostForum: function goPostForum() {
      if (this.isLimited) {
        location.href = this.appInfo.app_download;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({
          name: 'CirclePost',
          query: {
            circle_id: this.$route.query.circle_id,
            type_value: this.$route.query.type_value
          }
        });
      }
    },
    jumpToAppPage: function jumpToAppPage() {
      if (this.$utils.clientSystemType.isWx) {
        window.location.href = '/mag/index/v1/index/shareDownload';
      } else {
        var routeName = this.$route.name,
            jumpurl = this.appInfo.app_key + '://';
        var downloadUrl = this.appInfo.app_download;
        if (routeName === 'Index' || routeName === 'Circle' || routeName === 'Wshare' || routeName === 'Find' || routeName === 'User' || routeName === 'TopicHot' || routeName === 'UserHome' || routeName === 'CirclePost') {
          jumpurl = '';
        }
        switch (routeName) {
          case 'CirclePostList':
            jumpurl = jumpurl + 'forumThreadList?fid=' + this.$route.query.type_value + '&circleId=' + this.$route.query.circle_id;
            break;
          case 'WshareList':
            jumpurl = jumpurl + 'showList?circleId=' + this.$route.query.circle_id;
            break;
          case 'PunchList':
            jumpurl = jumpurl + 'punchCardList?circle_id=' + this.$route.query.circle_id;
            break;
          case 'TopicIndex':
            jumpurl = jumpurl + 'topicContentList?topic_id=' + this.$route.query.id;
            break;
          case 'AllTools':
            jumpurl = jumpurl + 'toollist';
            break;
          case 'AllActivities':
            jumpurl = jumpurl + 'activitylist';
            break;
          case 'MineProfile':
            jumpurl = jumpurl + 'useredit';
            break;
          case 'UserFans':
            jumpurl = jumpurl + 'fanslist';
            break;
          case 'UserFollows':
            jumpurl = jumpurl + 'followlist';
            break;
          case 'FriendsDynamic':
            jumpurl = jumpurl + 'friendTimeline';
            break;
        }
        this.$utils.jumpToAppPage(jumpurl, downloadUrl);
      }
    }
  }
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_lazyload__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_style_min_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_style_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_style_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_wap_wapcommon_scss__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_wap_wapcommon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_scss_wap_wapcommon_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_store__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(67);


Vue.use(__WEBPACK_IMPORTED_MODULE_0_vue_lazyload___default.a);






Vue.use(__WEBPACK_IMPORTED_MODULE_3_mint_ui___default.a);






Vue.prototype.$http = __WEBPACK_IMPORTED_MODULE_6__common_http__["a" /* default */];
Vue.prototype.$utils = __WEBPACK_IMPORTED_MODULE_8__common_utils__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_8__common_utils__["a" /* default */].initRem();

Vue.directive('fontemojtopic', {
  bind: function bind(el, binding, vnode) {
    if (binding.value) {
      __WEBPACK_IMPORTED_MODULE_8__common_utils__["a" /* default */].filterEmojTextToImg(binding.value, function (content) {
        var content = content.replace(/#.[^#]*#/g, function (item) {
          return '<span class="link-jump">' + item + '</span>&nbsp;';
        });
        el.innerHTML = content;
      });
    }
  }
});

new Vue({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__common_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_store__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(67);




Vue.use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);

function getScrollTop() {
  var scrollTop = 0;
  if (__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].clientSystemType.isIOS || __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].clientSystemType.isAndroid) {
    scrollTop = document.body.scrollTop;
  } else {
    scrollTop = document.documentElement.scrollTop;
  }
  return scrollTop;
}

function setScrollTop(scroll_top) {
  document.documentElement.scrollTop = scroll_top;
  document.body.scrollTop = scroll_top;
}

var router = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
  mode: 'history',

  saveScrollPosition: true,

  base: '/mag/wap/v1/wap/waphome',

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.meta.keepAlive) {
      var scrollTop = __WEBPACK_IMPORTED_MODULE_1__common_store__["a" /* default */].state.common.scrollPos[to.name] || 0;
      setTimeout(function () {
        setScrollTop(scrollTop);
      }, 0);
      return {
        x: 0,
        y: scrollTop
      };
    }
  },


  routes: [{
    path: '/test',
    name: 'Test',
    component: function component(resolve) {
      __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '测试'
    }
  }, {
    path: '/',
    name: 'Entry',
    component: function component(resolve) {
      __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    redirect: {
      name: 'Index'
    },
    children: [{
      path: '/index',
      name: 'Index',
      component: function component(resolve) {
        __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(307)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      alias: '/',
      meta: {
        keepAlive: true
      }
    }, {
      path: '/circle',
      name: 'Circle',
      component: function component(resolve) {
        __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(301)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        keepAlive: true
      }
    }, {
      path: '/thirdlink1',
      component: function component(resolve) {
        __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(315)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/thirdlink2',
      component: function component(resolve) {
        __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(316)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/thirdlink3',
      component: function component(resolve) {
        __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(317)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/thirdlink4',
      component: function component(resolve) {
        __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(318)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/thirdlink5',
      component: function component(resolve) {
        __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(319)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/wshare',
      name: 'Wshare',
      component: function component(resolve) {
        __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(328)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        keepAlive: true
      }
    }, {
      path: '/find',
      name: 'Find',
      component: function component(resolve) {
        __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(306)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        keepAlive: true
      }
    }, {
      path: '/user',
      name: 'User',
      component: function component(resolve) {
        __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(323)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }, {
    path: '/circlepostlist',
    name: 'CirclePostList',
    component: function component(resolve) {
      __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      keepAlive: true
    }
  }, {
    path: '/circledetail',
    name: 'CircleDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(300)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/circlepost',
    name: 'CirclePost',
    component: function component(resolve) {
      __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(302)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '发帖'
    }
  }, {
    path: '/wsharelist',
    name: 'WshareList',
    component: function component(resolve) {
      __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(296)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/wsharepost',
    name: 'WsharePost',
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(329)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '发布动态'
    }
  }, {
    path: '/punchlist',
    name: 'PunchList',
    component: function component(resolve) {
      __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(330)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/topichot',
    name: 'TopicHot',
    component: function component(resolve) {
      __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(331)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '热门话题'
    }
  }, {
    path: '/topicindex',
    name: 'TopicIndex',
    component: function component(resolve) {
      __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(332)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '话题首页'
    }
  }, {
    path: '/alltools',
    name: 'AllTools',
    component: function component(resolve) {
      __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(305)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '全部工具'
    }
  }, {
    path: '/allactivities',
    name: 'AllActivities',
    component: function component(resolve) {
      __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '全部活动'
    }
  }, {
    path: '/mineprofile',
    name: 'MineProfile',
    component: function component(resolve) {
      __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(325)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '我的'
    }
  }, {
    path: '/userhome',
    name: 'UserHome',
    component: function component(resolve) {
      __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(295)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '我的主页'
    }
  }, {
    path: '/userfans',
    name: 'UserFans',
    component: function component(resolve) {
      __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(320)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/userfollows',
    name: 'UserFollows',
    component: function component(resolve) {
      __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(321)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/friendsdynamic',
    name: 'FriendsDynamic',
    component: function component(resolve) {
      __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(322)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '好友动态'
    }
  }, {
    path: '/signup',
    name: 'UserSignUp',
    component: function component(resolve) {
      __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(326)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用户注册'
    }
  }, {
    path: '/userinfo',
    name: 'UserInfo',
    component: function component(resolve) {
      __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(327)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '完善资料'
    }
  }, {
    path: '/login',
    name: 'UserLogin',
    component: function component(resolve) {
      __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(324)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用户登陆'
    }
  }, {
    path: "/merchantlist",
    name: "merchantList",
    component: function component(resolve) {
      __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(313)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "全部商家"
    }
  }, {
    path: "/merchant/profile",
    name: "merchantProfile",
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(314)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "商家主页"
    }
  }, {
    path: "/merchant/circle",
    name: "merchantCircle",
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(310)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "商家圈"
    }
  }, {
    path: "/merchant/coupons",
    name: "merchantCoupons",
    component: function component(resolve) {
      __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(312)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "所有优惠"
    }
  }, {
    path: "/merchant/circlelist",
    name: "merchantCircleList",
    component: function component(resolve) {
      __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(311)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "全部圈子"
    }
  }, {
    path: "/merchant/allshop",
    name: "merchantAllShop",
    component: function component(resolve) {
      __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(309)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "门店"
    }
  }, {
    path: "/merchant/album",
    name: "merchantAlbum",
    component: function component(resolve) {
      __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(308)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "相册"
    }
  }, {
    path: "/wshare/topicspecial",
    name: "topicSpeicl",
    component: function component(resolve) {
      __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(333)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: "专题"
    }
  }, {
    path: "/channel",
    name: "Channel",
    component: function component(resolve) {
      __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

router.beforeResolve(function (to, from, next) {
  if (from.name) {
    var scrollTop = getScrollTop();
    __WEBPACK_IMPORTED_MODULE_1__common_store__["a" /* default */].dispatch('updatePageScrollTop', {
      routeName: from.name,
      scrollPosTop: scrollTop
    });
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'normal-state': !_vm.showBar
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.showBar) ? _c('div', {
    staticClass: "top-bar"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.appInfo.app_logo,
      "width": "36",
      "height": "36",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.appInfo.app_name))]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.appInfo.app_des))])]), _vm._v(" "), _c('span', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showBar = false
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.themecolor),
      expression: "themecolor"
    }],
    staticClass: "btn-openapp magx-btn theme-bg-color",
    on: {
      "click": _vm.jumpToAppPage
    }
  }, [_vm._v("立即打开")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-jump-overlay overlay"
  }, [_c('div', {
    staticClass: "app-jump-dialog dialog"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.appInfo.app_logo),
      expression: "appInfo.app_logo"
    }],
    staticClass: "app-logo",
    attrs: {
      "width": "78",
      "height": "78"
    }
  }), _vm._v(" "), (_vm.isInWeixin) ? _c('p', {
    staticClass: "des"
  }, [_vm._v("QQ／微信内限制无法进行此操作，请打开客户端后重试")]) : _vm._e(), _vm._v(" "), (!_vm.isInWeixin) ? _c('a', {
    staticClass: "button button-installed theme-bg-color"
  }, [_vm._v("已安装 > 打开应用查看本页")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button theme-bg-color",
    attrs: {
      "href": _vm.appInfo.app_download
    }
  }, [_vm._v("未安装 > 前去下载客户端")])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-btm-icons"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFixedIndex),
      expression: "showFixedIndex"
    }],
    staticClass: "item",
    attrs: {
      "to": {
        path: '/'
      },
      "tag": "div"
    }
  }, [_c('span', {
    staticClass: "icon icon-gohome"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPostForum),
      expression: "showPostForum"
    }],
    staticClass: "item",
    on: {
      "click": _vm.goPostForum
    }
  }, [_c('span', {
    staticClass: "icon icon-post-forum"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("发帖")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPostWshare),
      expression: "showPostWshare"
    }],
    staticClass: "item",
    on: {
      "click": _vm.goPostWshare
    }
  }, [_c('span', {
    staticClass: "icon icon-post-topic"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("拍摄")])])], 1), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAWCAYAAAAb+hYkAAAAAXNSR0IArs4c6QAAAN9JREFUOBFjXLVqFdv79++72djY2hMTE18wEAGYgBragOryfv36tX/+/PkSROhhYOLg4GgHKrwIxBrEamQEmbxw4ULhHz9+7AUy9YH4BtCpjvicCtZEqka4JlI0omgiViOGJmI0YtVESCNOTfg04tWEpPEUkK0ExDc4OTlNmEAS+AAwwt0YGRnloWqWxcXFfcVr0+zZsyP///+/GIiZgZrq0tPTm0GacWrCpQGnJnwasGoipAFDEzEaUDQRqwGuiRQNYE2kagBpYgJG3Bcg/ReI4fEAkiAIgGWDKkFFSAoAKyrC38XxE/cAAAAASUVORK5CYII="

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);




var axios = __webpack_require__(140);

var config = __webpack_require__(138),
    host = '';
if ('"' + "production" + '"' == config.dev.env.NODE_ENV) {
    host = 'http://magapp-x.net/';
} else {
    host = window.location.origin;
}
var http = axios.create({
    baseURL: host
});

/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(api, params, success, fail) {
        if (typeof params.needLoadingIndicator === 'undefined') {
            params.needLoadingIndicator = true;
        }
        if (params.needLoadingIndicator) {
            __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Indicator"].open();
        }
        http.get(api, {
            params: params
        }).then(function (response) {
            if (params.needLoadingIndicator) {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Indicator"].close();
                }, 500);
            }
            if (success) {
                success(response.data);
            }
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Indicator"].close();

            if (error.message === 'Network Error') {}
            if (fail) {
                fail(error);
            }
        });
    },
    post: function post(api, params, callback, fail) {
        if (typeof params.needLoadingIndicator === 'undefined') {
            params.needLoadingIndicator = true;
        }
        if (params.needLoadingIndicator) {
            __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Indicator"].open();
        }
        http.post(api, __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Indicator"].close();
            if (callback) {
                callback(response.data);
            }
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Indicator"].close();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["Toast"])(error);
            if (fail) {
                fail(error);
            }
        });
    }
});

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(37);




Vue.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  global_config: {},
  global_config_loaded: false,
  common: {
    scrollPos: {}
  }
};

var mutations = {
  changeLoadGlobalConfigStatus: function changeLoadGlobalConfigStatus(state, payload) {
    state.global_config_loaded = payload;
  },
  setGlobalConfig: function setGlobalConfig(state, payload) {
    state.global_config = payload;
  },
  setPageScrollPos: function setPageScrollPos(state, payload) {
    state.common.scrollPos[payload.routeName] = payload.scrollPosTop;
  }
};

var actions = {
  loadGlobalConfig: function loadGlobalConfig(context) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/mag/index/v1/Index/config', {
        needLoadingIndicator: false
      }, function (res) {
        context.commit('setGlobalConfig', res.data);
        context.commit('changeLoadGlobalConfigStatus', true);
        resolve(res.data);
      });
    });
  },
  updatePageScrollTop: function updatePageScrollTop(context, position) {
    context.commit('setPageScrollPos', position);
  }
};

var getters = {
  global_config: function global_config(state) {
    return state.global_config;
  },
  global_config_loaded: function global_config_loaded(state) {
    return state.global_config_loaded;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(22);




function appendThemeColorStyleNode(color) {
  var doc = document,
      mystyle = doc.createElement('style');
  mystyle.setAttribute('type', 'text/css');
  mystyle.innerHTML = '.theme-font-color{color:#' + color + ';}.theme-bg-color{ background-color:#' + color + ';}.theme-border-color{ border-color:#' + color + ';}';
  doc.getElementsByTagName('head')[0].appendChild(mystyle);
}

function locationSearchParser(link) {
  var searchString = link || window.location.search,
      searchString = searchString.substr(searchString.indexOf('?')),
      searchString = searchString.replace(/\?/g, ''),
      dict = {};
  if (searchString) {
    var paramArr = searchString.split('&');
    for (var item in paramArr) {
      var itemStr = paramArr[item];
      var pairArr = itemStr.split('=');
      dict[pairArr[0]] = pairArr[1];
    }
  }
  return dict;
}

var emotionsText = [];
function getEmotionsKey(callback) {
  if (emotionsText.length) {
    if (callback) {
      callback();
    }
    return;
  } else {
    __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/mag/circle/v1/show/getEmotionsKey', {
      needLoadingIndicator: false
    }, function (res) {
      if (res.success) {
        emotionsText = res.list;
        if (callback) {
          callback();
        }
      }
    });
  }
}
getEmotionsKey();
function filterEmojImgsToText(content, callback) {
  getEmotionsKey(function () {
    content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (src) {
      var text = '';
      src = src.replace(/face_[0-9]+\.png/g, function (item) {
        var value = item.replace('face_', '');
        if (emotionsText[parseInt(value)]) {
          text = '{:' + emotionsText[parseInt(value)] + ':}';
        }
      });
      return text;
    });
    if (callback) {
      callback(content);
    }
  });
}

function filterEmojTextToImg(content, callback) {
  if (!content) return;
  getEmotionsKey(function () {
    content = content.replace(/{:[\u4e00-\u9fa5]+:}/g, function (text) {
      var res = '';
      text.replace(/[\u4e00-\u9fa5]+/g, function (item) {
        for (var i = 0; i < emotionsText.length; i++) {
          if (emotionsText[i] === item) {
            if (i < 10) {
              i = '00' + i;
            } else if (10 <= i < 100) {
              i = '0' + i;
            }

            var src = window.location.origin + '/public/emotion/face_' + i + '.png';
            res = '<img class="img-emoj" src="' + src + '">';
          }
        }
      });
      return res;
    });
    if (callback) {
      callback(content);
    }
  });
}

var appVersion = window.navigator.appVersion.toLowerCase();
var clientSystemType = {
  isIOS: appVersion.indexOf('iphone') != -1,
  isAndroid: appVersion.indexOf('android') != -1,
  isInMagappX: appVersion.indexOf('magappx') != -1,
  isWx: appVersion.indexOf('micromessenger') != -1
};

var API_WSHARE_DETAIL = '/mag/circle/v1/show/wapShowView';
var API_FORUM_DETAIL = '/mag/circle/v1/forum/threadWapPage';
var API_INFO_DETAIL = '/mag/info/v1/info/wapInfoView';
var API_PORTAL_INFO_DETAIL = '/mag/info/v1/portalInfo/wapInfoView';

/* harmony default export */ __webpack_exports__["a"] = ({
  clientSystemType: clientSystemType,
  setShareData: function setShareData(options) {
    var shareTitle = options ? options.title : window.ShareTitle,
        shareDesc = options ? options.desc : window.ShareDesc,
        shareLink = window.location.href,
        shareImg = options ? options.img : window.ShareIcon;
    __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/mag/user/v1/wxwap/getSignPackage', {
      needLoadingIndicator: false,
      url: location.href.split('#')[0]
    }, function (res) {
      if (res.success) {
        wx.config({
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'previewImage', 'scanQRCode']
        });
        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: shareTitle,
            link: shareLink,
            imgUrl: shareImg
          });
          wx.onMenuShareAppMessage({
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImg
          });
        });
        wx.error(function (res) {});
      }
    });
  },
  initRem: function initRem() {
    var docEl = document.documentElement,
        clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    if (clientWidth > 640) {
      docEl.style.fontSize = 10 + 'px';
    } else {
      docEl.style.fontSize = 10 * (clientWidth / 320) + 'px';
    }
  },


  appendThemeColorStyleNode: appendThemeColorStyleNode,

  locationSearchParser: locationSearchParser,

  filterEmojTextToImg: filterEmojTextToImg,

  pageIsInThirdPlatform: function pageIsInThirdPlatform() {
    var ua = window.navigator.userAgent.toLowerCase(),
        platqq = 'qq/',
        platweibo = 'weibo',
        platwx = 'micromessenger',
        res = false;
    if (ua.indexOf(platwx) != -1 || ua.indexOf(platqq) != -1 || ua.indexOf(platweibo) != -1) {
      res = true;
    }
    return res;
  },
  jumpToAppPage: function jumpToAppPage(jumpurl) {
    var jumpurl = jumpurl || '';
    var protocol = window.AppJumpProtocol;
    var currentHref = encodeURIComponent(window.location.href),
        jumpPath = encodeURIComponent(jumpurl),
        jumpUrlForWeixin = 'https://api.magcloud.cc/magshare/' + protocol + '?content_url=' + currentHref + '&jump_url=' + jumpPath;
    if (this.pageIsInThirdPlatform()) {
      if (clientSystemType.isAndroid) {
        $('.app-jump-overlay').fadeIn('fast', function () {
          $(this).find('.button-installed').attr('href', protocol + '://pagejump?jump_url=' + jumpPath);
        });
      } else {
        window.location.href = jumpUrlForWeixin;
      }
    } else {
      $('.app-jump-overlay').fadeIn('fast', function () {
        $(this).find('.button-installed').attr('href', protocol + '://pagejump?jump_url=' + jumpPath);
      });
    }
  },
  goLogin: function goLogin() {
    if (clientSystemType.isWx) {
      window.location.href = '/mag/user/v1/wxwap/toWeiXinAuthorLogin?return_url=' + encodeURIComponent(window.location.href);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        name: 'UserLogin'
      });
    }
  },
  goShowDetail: function goShowDetail(id) {
    window.location.href = API_WSHARE_DETAIL + '?content_id=' + id + '&themecolor=' + window.AppThemeColor;
  },
  goForumDetail: function goForumDetail(id, circle_id) {
    window.location.href = API_FORUM_DETAIL + '?tid=' + id + '&circle_id=' + circle_id + '&themecolor=' + window.AppThemeColor;
  },
  goDetailFromIndex: function goDetailFromIndex(link) {
    var url = '',
        me = this,
        params = locationSearchParser(link);
    if (link.indexOf('http') !== -1) {
      url = link;
    }
    if (link.indexOf('://showView') !== -1) {
      url = API_WSHARE_DETAIL + '?content_id=' + params.id + '&themecolor=' + window.AppThemeColor;
    }
    if (link.indexOf('/mag/circle/v1/forum/threadViewPage') !== -1) {
      url = API_FORUM_DETAIL + '?tid=' + params.tid + '&circle_id=' + params.circle_id + '&themecolor=' + window.AppThemeColor;
    }
    if (link.indexOf('/mag/info/v1/info/infoView') !== -1) {
      url = API_INFO_DETAIL + '?id=' + params.id + '&themecolor=' + window.AppThemeColor;
    }
    if (link.indexOf('/mag/info/v1/portalInfo/infoView') !== -1) {
      url = API_PORTAL_INFO_DETAIL + '?id=' + params.id + '&themecolor=' + window.AppThemeColor;
    }
    if (url) {
      window.location.href = url;
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"])({
        title: '提示',
        message: 'QQ／微信内暂不能查看，前往客户端查看',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (action) {
        if (action === 'confirm') {
          me.jumpToAppPage(url);
        }
      });
    }
  },
  toolItemJump: function toolItemJump(link) {
    var me = this;
    var params = locationSearchParser(link);

    if (link.indexOf('channelList') >= 0) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        name: 'Channel',
        query: {
          channel_id: params.channel_id
        }
      });
      return;
    }
    if (link && link.indexOf('http') >= 0) {
      if (link.indexOf('threadViewPage') !== -1) {
        link = link.replace('threadViewPage', 'threadWapPage');
      }
      if (link.indexOf('infoView') !== -1) {
        link = link.replace('infoView', 'wapInfoView');
      }
      if (link.indexOf('showView') !== -1) {
        link = API_WSHARE_DETAIL + '?content_id=' + params.id;
      }
      if (link.indexOf('?') < 0) {
        link = link + '?themecolor=' + window.AppThemeColor;
      } else {
        link = link + '&themecolor=' + window.AppThemeColor;
      }
      window.location.href = link;
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"])({
        title: '提示',
        message: 'QQ／微信内暂不能查看，前往客户端查看',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (action) {
        if (action === 'confirm') {
          me.jumpToAppPage(link);
        }
      });
    }
  },
  setTabPageTitle: function setTabPageTitle() {
    document.title = $('.btm-tabbar .item.router-link-exact-active').attr('naviname') || '';
  },
  getThirdPageLink: function getThirdPageLink() {
    var link = $('.btm-tabbar .item.router-link-exact-active').attr('thirdlink') || '';
    return decodeURIComponent(link);
  },
  setupScroller: function setupScroller(options) {
    var timer = null;
    options.listCopyed[0].innerHTML = options.listOri[0].innerHTML;
    if (options.listContainer[0].parentElement) {
      timer = setInterval(function () {
        if (options.listContainer[0].parentElement.scrollTop == options.listOri[0].offsetHeight) {
          options.listContainer[0].parentElement.scrollTop = 0;
        } else {
          options.listContainer[0].parentElement.scrollTop++;
        }
      }, 50);
    }
    return timer;
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ })

},[159]);


// WEBPACK FOOTER //
// static/js/app.a006903e6e3a5e2601c3.js